import Typography from '@mui/material/Typography';

import { Button } from '@/components/ui/Button';
import { CollapsibleCard } from '@/components/ui/CollapsibleCard';

import { State } from '../State';

export function CollapsibleCardExamples() {
  return (
    <>
      <State title="Open" note="The body stays mounted when folded, so typing survives.">
        <CollapsibleCard
          title="Details"
          description="Open on first render, because it is what the page is for."
          defaultExpanded
          testId="gallery-collapsible-card-open-card"
        >
          <Typography variant="body2">The section&apos;s content.</Typography>
        </CollapsibleCard>
      </State>

      <State
        title="With actions, switched off"
        note="Controls sit beside the fold button, never inside it. A muted title marks a section that is switched off."
      >
        <CollapsibleCard
          title="Guides"
          muted
          meta={<Typography variant="body2">0 items</Typography>}
          actions={
            <Button
              variant="ghost"
              size="sm"
              data-testid="gallery-collapsible-card-action-button"
            >
              Edit
            </Button>
          }
          testId="gallery-collapsible-card-actions-card"
        >
          <Typography variant="body2">Nothing in this section yet.</Typography>
        </CollapsibleCard>
      </State>

      <State title="Closed">
        <CollapsibleCard
          title="Billing"
          description="Folded until it is wanted."
          testId="gallery-collapsible-card-closed-card"
        >
          <Typography variant="body2">
            Twenty fields nobody has to scroll past.
          </Typography>
        </CollapsibleCard>
      </State>
    </>
  );
}
